import React from "react";
import { Grid, TextField } from "@mui/material";

const ManagementStep = ({ formData, handleChange }) => {
  return (
    <Grid container spacing={2.5}>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Sales Person" name="salesPerson" value={formData.salesPerson} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Lab Rep" name="labRep" value={formData.labRep} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Project Manager" name="projectManager" value={formData.projectManager} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="PO Number" name="poNumber" value={formData.poNumber} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="SIC Code" name="sicCode" value={formData.sicCode} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Division Code" name="divisionCode" value={formData.divisionCode} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Expiration Date"
          name="expirationDate"
          type="date"
          value={formData.expirationDate}
          onChange={handleChange}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField
          label="Contract Expiration"
          name="contractExp"
          type="date"
          value={formData.contractExp}
          onChange={handleChange}
          fullWidth
          size="small"
          InputLabelProps={{ shrink: true }}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="TA Days" name="taDays" type="number" value={formData.taDays} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Regulatory Email" name="regulatoryEmail" value={formData.regulatoryEmail} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="DOH Source" name="dohsource" value={formData.dohsource} onChange={handleChange} fullWidth size="small" />
      </Grid>
      <Grid item xs={12} sm={6} md={3}>
        <TextField label="Multiple Source" name="multiplesource" value={formData.multiplesource} onChange={handleChange} fullWidth size="small" />
      </Grid>
    </Grid>
  );
};

export default ManagementStep;
